import form from "../Form.module.css";
import { FieldRate } from "./FieldRate";
import { FieldTimeOfDay } from "./FieldTimeOfDay";
import { FieldTimezone } from "./FieldTimezone";

import type { Dispatch, SetStateAction } from "react";
import type { FormState } from "../FormState";
import { hasTimeOfDay } from "../cron/optionsRate";

interface Props<FState> {
  state: FState;
  setState: Dispatch<SetStateAction<FState>>;
}

export function CronSchedule<FState extends FormState>(props: Props<FState>) {
  const { state, setState } = props;

  return (
    <>
      <div className={form.row}>
        <FieldRate state={state} setState={setState} />
      </div>

      {hasTimeOfDay(state.cronString) && (
        <div className={form.row}>
          <FieldTimeOfDay state={state} setState={setState} />
          <FieldTimezone state={state} setState={setState} />
        </div>
      )}
    </>
  );
}
